import { useEffect, useRef } from 'react';
import { useAccountTradingDataContext } from 'src/hooks/globalSyncs/accountSync/AccountTradingDataProvider';

export function useWarnIfProviderMissing(hookName: string) {
	const isProviderMounted = useAccountTradingDataContext();
	const hasWarnedRef = useRef(false);

	useEffect(() => {
		if (
			process.env.NODE_ENV === 'development' &&
			!isProviderMounted &&
			!hasWarnedRef.current
		) {
			hasWarnedRef.current = true;
			console.warn(
				`${hookName}: AccountTradingDataProvider is not mounted. ` +
					'This hook will return undefined until the provider is available.'
			);
		}
	}, [isProviderMounted, hookName]);
}
